export const appendModalToDom = (className, options = {}) => {
  let purchaseIntentModalEl = document.querySelector(`.${className}`);

  if (!purchaseIntentModalEl) {
    purchaseIntentModalEl = document.createElement('div');
    document.body.appendChild(purchaseIntentModalEl);
    purchaseIntentModalEl.classList.add(className);
    purchaseIntentModalEl.style.display = 'none';
    purchaseIntentModalEl.style.zIndex = options.zIndex || 10000;
    purchaseIntentModalEl.style.position = 'fixed';
    purchaseIntentModalEl.style.top = 0;
    purchaseIntentModalEl.style.left = 0;
    purchaseIntentModalEl.style.height = '100%';
    purchaseIntentModalEl.style.width = '100%';
  }

  return purchaseIntentModalEl;
};
